import { RouteRecordRaw, RouteRecordRedirect } from "vue-router";
import { unzipView } from "@/router/modules/view.apiunzip.module";
import { needLogin, noNeedLogin } from "@/middlewares/auth.middleware";

// Create an array of RouteRecordRaw objects
const routes: Array<RouteRecordRaw | RouteRecordRedirect> = unzipView.map(
  ({ path, name, component, isAuthenticated }) => {
    const children: Array<RouteRecordRaw> = [];

    return {
      path,
      name,
      component,
      beforeEnter: isAuthenticated ? needLogin : noNeedLogin,
      children,
    };
  }
);

routes.push(
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error-view",
  }
);

export default routes;
